











import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class RadioButtonBox extends Vue {
  @Prop() value!: string;
  @Prop() model!: string;
  @Prop() name!: string;
  @Prop({ default: false }) disabled!: boolean;

  public onClick(): void {
    if (this.disabled) return;
    this.updateItem(this.value, "model");
  }

  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
  }
}
